<template>
  <div>
    <v-container class="mt-5 ml-2" fluid v-if="puedeVer">
      <v-row>
        <v-col cols="12">
          <v-card class="transparent elevation-0">
            <v-card-title primary-title class="text-subtitle-1">
              {{ titulo }}
              <v-spacer></v-spacer>
              <v-btn color="primary" small tile @click="recargar">
                Consultar
              </v-btn>
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col cols="12" md="6">
                  <GraficaMetaRi
                    :titulo="cicloTexto || 'RI al momento'"
                    subtitulo="RI semana 2"
                    :planteles="plantelesUsuario"
                    :color="colorEscuela"
                    :cargando="cargandoBono"
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-card class="shadowCard panel-ri-semana">
                    <v-card-text class="pa-4">
                      <div class="panel-head">
                        <div class="panel-kicker">
                          <v-icon small color="indigo darken-1" class="mr-1">mdi-account-reactivate</v-icon>
                          RI a semana 2
                        </div>
                        <div class="panel-rango" v-if="fechaInicio || fechaCorteMostrada">
                          {{ formatFecha(fechaInicio) || '—' }}
                          <span class="mx-1">→</span>
                          {{ formatFecha(fechaCorteMostrada) || '—' }}
                        </div>
                        <div class="panel-etiqueta">{{ etiquetaEscuela }}</div>
                      </div>

                      <TarjetaDiasInscripcion
                        embebida
                        :fecha-inicio="formatFecha(fechaInicio)"
                        :fecha-fin="formatFecha(fechaCorteMostrada)"
                        :dias="diasFaltantes(fechaCorteMostrada)"
                      />
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <v-row class="mt-4">
                <v-col
                  v-for="fila in filasPorPlantel"
                  :key="'bono-ri-' + fila.id_plantel"
                  cols="12"
                >
                  <TarjetaMiBonoRI
                    :fila="fila"
                    :ciclo-act="cicloAct"
                    :ciclo-sig="cicloSig"
                    :fecha_corte="fechaCorteMostrada"
                    :cargando="cargandoBono"
                  />
                </v-col>
              </v-row>

              <v-row class="mt-4">
                <v-col cols="12">
                  <TablaBonoRI
                    ref="tablaBonoRI"
                    :escuela="escuela"
                    :titulo="tituloTabla"
                    solo-asignadas
                    @resumen="onResumen"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else class="mt-5 ml-2" fluid>
      <v-alert type="error" prominent>
        No tienes permiso para ver este reporte.
      </v-alert>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TablaBonoRI from '@/components/kpi/TablaBonoRI.vue'
import TarjetaMiBonoRI from '@/components/kpi/TarjetaMiBonoRI.vue'
import TarjetaDiasInscripcion from '@/components/kpi/TarjetaDiasInscripcion.vue'
import GraficaMetaRi from '@/components/kpi/GraficaMetaRi.vue'

const IDERPS_ACCESO = [334, 568, 3121]
const PUESTOS_ACCESO = [11, 40, 88, 19, 18 ]

export default {
  name: 'RIMomentoEscuela',

  components: {
    TablaBonoRI,
    TarjetaMiBonoRI,
    TarjetaDiasInscripcion,
    GraficaMetaRi,
  },

  props: {
    escuela: { type: Number, required: true },
    titulo: { type: String, required: true },
  },

  data() {
    return {
      resumen: {},
      filasBono: [],
      cicloAct: null,
      cicloSig: null,
      fecha_corte: '',
      cargandoBono: false,
    }
  },

  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),
    puedeVer() {
      const u = this.getdatosUsuarioERPERP || {}
      const id = Number(u.iderp)
      const puesto = Number(u.idpuesto)
      return IDERPS_ACCESO.includes(id) || PUESTOS_ACCESO.includes(puesto)
    },
    colorEscuela() {
      return Number(this.escuela) === 2 ? 'red' : 'blue'
    },
    tituloTabla() {
      return Number(this.escuela) === 2 ? 'Bono de RI FAST' : 'Bono de RI INBI'
    },
    etiquetaEscuela() {
      if (this.plantelesUsuario.length === 1) return this.plantelesUsuario[0].plantel
      return Number(this.escuela) === 2 ? 'RI FAST' : 'RI INBI'
    },
    cicloTexto() {
      const act = this.cicloAct && this.cicloAct.ciclo
      const sig = this.cicloSig && this.cicloSig.ciclo
      if (act && sig) return `${act} → ${sig}`
      return act || ''
    },
    plantelesUsuario() {
      return (this.resumen && this.resumen.porPlantel) || []
    },
    filasPorPlantel() {
      const vistos = {}
      const lista = []
      ;(this.filasBono || []).forEach((f) => {
        const idp = Number(f.id_plantel)
        if (!idp || vistos[idp]) return
        vistos[idp] = true
        lista.push(f)
      })
      if (lista.length) return lista
      return (this.plantelesUsuario || []).map((p) => ({
        id_plantel: p.id_plantel,
        plantel: p.plantel,
        reinscribibles: p.reinscribibles,
        objetivo: p.objetivo,
        lleva: p.lleva,
        lleva_s2: p.lleva,
        faltan: p.faltan,
        meta: p.meta,
        bono_personal: 0,
        alcanzado_s2: p.objetivo > 0 && p.lleva >= p.objetivo,
      }))
    },
    fechaInicio() {
      return this.sumarDias(this.fecha_corte, -14)
    },
    fechaCorteMostrada() {
      return this.sumarDias(this.fecha_corte, -1)
    },
  },

  methods: {
    ymd(fecha) {
      if (!fecha) return ''
      return String(fecha).slice(0, 10)
    },
    sumarDias(fecha, dias) {
      const ymd = this.ymd(fecha)
      if (!ymd) return ''
      const [y, m, d] = ymd.split('-').map(Number)
      if (!y || !m || !d) return ''
      const dt = new Date(y, m - 1, d)
      dt.setDate(dt.getDate() + dias)
      const pad = (n) => String(n).padStart(2, '0')
      return `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())}`
    },
    onResumen(payload) {
      this.resumen = (payload && payload.resumen) || {}
      this.filasBono = (payload && payload.filas) || []
      this.cicloAct = payload && payload.cicloAct
      this.cicloSig = payload && payload.cicloSig
      this.fecha_corte = (payload && payload.fecha_corte) || ''
      this.cargandoBono = !!(payload && payload.cargando)
    },
    recargar() {
      const tabla = this.$refs.tablaBonoRI
      if (tabla && typeof tabla.cargarFilas === 'function') tabla.cargarFilas()
    },
    formatFecha(fecha) {
      const ymd = this.ymd(fecha)
      if (!ymd) return ''
      const meses = [
        'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
        'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre',
      ]
      const [y, m, d] = ymd.split('-').map(Number)
      if (!y || !m || !d) return ymd
      return `${String(d).padStart(2, '0')} de ${meses[m - 1]}`
    },
    diasFaltantes(fechaObjetivo) {
      const ymd = this.ymd(fechaObjetivo)
      if (!ymd) return null
      const [y, m, d] = ymd.split('-').map(Number)
      if (!y || !m || !d) return null
      const corte = new Date(y, m - 1, d)
      const hoy = new Date()
      corte.setHours(0, 0, 0, 0)
      hoy.setHours(0, 0, 0, 0)
      const diff = Math.ceil((corte - hoy) / 86400000)
      if (diff < 0) return diff
      return diff + 1
    },
  },
}
</script>

<style scoped>
.panel-ri-semana {
  height: 100%;
}

.panel-head {
  text-align: center;
  margin-bottom: 16px;
}

.panel-kicker {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.1px;
  text-transform: uppercase;
  color: #3949ab;
}

.panel-rango {
  margin-top: 4px;
  font-size: 15px;
  font-weight: 700;
  color: #263238;
}

.panel-etiqueta {
  margin-top: 2px;
  font-size: 12px;
  color: #78909c;
}
</style>
